<template>
    <!-- TODO: change 'md:container' to 'container' and adjust padding of nested elements -->
    <div class="md:container">
        <div
            v-if="content"
            class="max-w-3xl mx-auto"
        >
            <div class="max-md:container">
                <h1 class="font-display-3 md:font-display-2 lg:font-display-1 mt-3 mb-4 md:mt-7 md:mb-5">
                    {{ content.h1 }}
                </h1>

                <widgetHeroImage appearance="mb-6 md:mb-10">
                    <img
                        v-if="content.image !== null"
                        :alt="content.h1"
                        :src="content.image"
                        class="w-full rounded-lg"
                    />
                </widgetHeroImage>
            </div>

            <div
                v-for="item in content.widget"
                :key="item.id"
                class="mb-6 md:mb-5"
            >
                <component
                    :is="item.type"
                    :key="item.id"
                    :item="item"
                ></component>
            </div>
        </div>
        <TheFooterStatic class="mt-20"></TheFooterStatic>
    </div>
</template>

<script>
import Editorial from '@components/WidgetEditorial';
import Links from '@components/WidgetLink';
import WidgetHeroImage from '@components/WidgetHeroImage';
import TheFooterStatic from '@components/TheFooterStatic';
import Courses from './CoursesWidget.vue';
import Documents from './DocumentsWidget.vue';
import Flashcards from './FlashcardsWidget.vue';
import GroupDiscussions from './GroupDiscussionsWidget.vue';
import Groups from './GroupsWidget.vue';

export default {
    name: 'LandingPageIndex',
    components: {
        TheFooterStatic,
        WidgetHeroImage,
        Editorial,
        Links,
        Courses,
        Documents,
        Flashcards,
        Groups,
        GroupDiscussions,
    },
    data: () => ({
        content: window.sdWindow.data,
    }),
};
</script>

<style lang="scss" scoped>
h1 {
    word-break: break-word;
}
</style>
